import { Line, ReelWinPosition } from '@cgs/data-access';
import { ListUtil } from '@cgs/shared';
import {
  Container,
  EmptyAction,
  FunctionAction,
  IntervalAction,
  ParallelAction,
  SequenceAction,
} from '@cgs/wge';
import { ICustomWinLinesSoundActionProvider } from '../../../../reels_engine/game_components_providers/i_custom_win_lines_sound_action_provider';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  IGameStateMachineProvider,
} from '../../../../reels_engine/game_components_providers/i_game_state_machine_provider';
import { SpinConfig } from '../../../../reels_engine/game_config/game_config';
import { LineModel } from '../../../../reels_engine/line_model';
import { LinesSceneObject } from '../../../../reels_engine/lines_scene_object';
import { ReelsSoundModel } from '../../../../reels_engine/reels_sound_model';
import { T_ICustomWinLinesSoundActionProvider } from '../../../../type_definitions';
import { FAST_SPINS_COMPONENT, FastSpinsComponent } from '../../fast-spins.component';
import { AllWinLinesAction } from './all_win_lines_action';
import { ShortWinLinesAction } from './short_win_lines_action';

export class ShortWinLinesWithIconsAction extends ShortWinLinesAction {
  ReelSound: ReelsSoundModel;
  _customWinLineSoundActionProvider: ICustomWinLinesSoundActionProvider | null;
  _action: IntervalAction;

  constructor(
    container: Container,
    lineNode: LinesSceneObject,
    lineModel: LineModel,
    spinConfig: SpinConfig,
    winLines: Line[],
    winPositions: ReelWinPosition[],
    reelsSoundModel: ReelsSoundModel
  ) {
    super(container, winLines, winPositions, lineNode, lineModel, spinConfig, reelsSoundModel);
    console.log('load ' + this.constructor.name);
    this._customWinLineSoundActionProvider = container.resolve(
      T_ICustomWinLinesSoundActionProvider,
      { optional: true }
    );
    this._lineNode = lineNode;
    this.ReelSound = reelsSoundModel;
    this._action = this.CreateAction(container, winLines);
    this.withDuration(this._action.duration);
  }

  buildAction(): IntervalAction {
    return this._action;
  }

  CreateAction(container: Container, winLines: Line[]): IntervalAction {
    if (
      winLines.length === 0 &&
      this.winPositions.length === 0 &&
      !this._customWinLineSoundActionProvider
    ) {
      return new EmptyAction().withDuration(this.spinConfig.noWinDelay);
    }

    const gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;
    const fastSpinsController = container.resolve<FastSpinsComponent>(FAST_SPINS_COMPONENT);

    return fastSpinsController.isFastSpinsActive &&
      (gameStateMachine.isAutoSpins || gameStateMachine.curResponse.isFreeSpins)
      ? new SequenceAction([
          new ParallelAction([
            this.fastBlinkAllLines(),
            new AllWinLinesAction(
              container,
              ListUtil.union(
                winLines,
                this.winPositions.map((position) => {
                  const line = new Line();
                  line.positions = position.positions;
                  line.symbolId = position.symbolId;
                  return line;
                })
              )
            ),
            this.logoAnimationProvider
              ? this.logoAnimationProvider.getShortWinLineAction()
              : new EmptyAction(),
          ]),
          new FunctionAction(() => this._lineNode.clear()),
          new EmptyAction().withDuration(0.2),
        ])
      : new SequenceAction([
          new ParallelAction([
            this.blinkAllLines(),
            new AllWinLinesAction(
              container,
              ListUtil.union(
                winLines,
                this.winPositions.map((position) => {
                  const line = new Line();
                  line.positions = position.positions;
                  line.symbolId = position.symbolId;
                  return line;
                })
              )
            ),
            this.logoAnimationProvider
              ? this.logoAnimationProvider.getShortWinLineAction()
              : new EmptyAction(),
          ]),
          new FunctionAction(() => this._lineNode.clear()),
          new EmptyAction().withDuration(0.2),
        ]);
  }
}
